import { FC } from 'react'
import { ValueType, OptionTypeBase } from 'react-select'

// Components
import Filter from './Filter'

interface FilterProps {
  id?: string
  className?: string
  onChange: (value: string) => void
  isCleareable?: boolean
  isSearchable?: boolean
  placeholder?: JSX.Element | string
  options: OptionTypeBase[]
}

const StaticFilter: FC<FilterProps> = ({
  id,
  className = '',
  placeholder = '',
  options,
  isCleareable = false,
  isSearchable = false,
  onChange,
}) => {
  const testId = id ? `static_filter_${id}` : 'static_filter'

  const handleChange = (option: ValueType<OptionTypeBase, false>) => {
    const newValue = option ? option.value : ''
    onChange(newValue)
  }

  return (
    <Filter
      dataTestId={testId}
      options={options}
      className={className}
      placeholder={placeholder}
      onChange={handleChange}
      isClearable={isCleareable}
      isSearchable={isSearchable}
    />
  )
}

export default StaticFilter
